<div class="card border-0" style="background-color: #b2d0dc" *transloco="let t; read: 'ime.components.dashboard'">
  <div class="card-body">
    <h4 class="card-title pb-3 d-flex justify-content-between">
      <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#bolt'">
      </svg>
      <a class="text-dark" [routerLink]="'../common/event'">
        {{title}}
      </a>
      <span class="ms-auto">
        <a href="javascript:void(0)" title="Filter errors/all" (click)="filterErrors()">
          <svg viewBox="0 0 8 8" class="icon" inlineSVG="{{showOnlyErrors ? '#x-circle' : '#information-circle'}}">
          </svg>
        </a>
      </span>
    </h4>
    <ul class="list-group list-group-flush">
      <ng-container *ngFor="let event of events$ | async">
        <li class="list-group-item " [class.bg-red-100]="event.Level === 0">
          <ng-container [ngSwitch]="event.Level">
            <ng-container *ngSwitchCase="0">
            <span class="text-danger">
              <svg viewBox="0 0 8 8" class="icon" inlineSVG="#x-circle">
              </svg>
            </span>
            </ng-container>
            <ng-container *ngSwitchCase="1">
              <span class="text-danger">
                <svg viewBox="0 0 8 8" class="icon" inlineSVG="#x-circle">
                </svg>
              </span>
            </ng-container>
            <ng-container *ngSwitchCase="2">
              <span class="text-warning">
                <svg viewBox="0 0 8 8" class="icon" inlineSVG="#exclamation-circle">
                </svg>
              </span>
            </ng-container>
            <ng-container *ngSwitchCase="3">
            <span class="text-info">
              <svg viewBox="0 0 8 8" class="icon" inlineSVG="#information-circle">
              </svg>
            </span>
            </ng-container>
            <ng-container *ngSwitchDefault>
            <span class="text-default">
              <svg viewBox="0 0 8 8" class="icon" inlineSVG="#information-circle">
              </svg>
            </span>
            </ng-container>
          </ng-container>
          <a href="javascript:void(0)" (click)="open(event.Id)" title="Click for details">
            <span class="badge bg-dark ms-2">{{event.Category}}</span>
            {{event.Description}}
          </a>
          <span class="text-muted">{{event.CreatedDate | date: 'short'}}</span>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
